import { FilterThemeProps } from 'common/filter/interfaces'

import { FilterConfig } from './types'

export const defaultFilterConfig: FilterConfig = {
  allowDateFormula: true,
  allowFormula: false,
  allowRemove: true,
  isConditionBuilder: false,
  isHiddenFirstGroup: false,
  onlyOneCondition: false,
  operatorSelectorAlwaysHidden: false,
  operatorSelectorAlwaysVisible: false,
  readOnlyGroupIndexes: [],
  readOnlyItemIndexesByGroup: {},
  useChangedLabelForOperators: false,
  renderSmartSegmentControl: () => null,
}

export const defaultTheme: FilterThemeProps = {}
